/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsGetUserObject204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsGetUserObject505Schema = z.any();

export const optionsGetUserObjectMutationResponseSchema = z.lazy(() => optionsGetUserObject204Schema);
